<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="跳转页面" prop="toPage">
                <a-select v-model="queryParam.toPage" placeholder="请选择" allow-clear>
                  <a-select-option value="1">单部剧详情</a-select-option>
                  <a-select-option value="2">rewards页面</a-select-option>
                  <a-select-option value="3">most trending</a-select-option>
                  <a-select-option value="4">剧集列表</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="推送用户" prop="toUser">
                <a-select v-model="queryParam.toUser" placeholder="请选择" allow-clear>
                  <a-select-option value="1">全站</a-select-option>
                  <a-select-option value="2">有资格的用户</a-select-option>
                  <a-select-option value="3">周/月/年订阅用户</a-select-option>
                  <a-select-option value="4">有金币消费历史用户</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons"
                :style="advanced && { float: 'right', overflow: 'hidden' } || {}">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['video:push:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" @click="$refs.createFormV2.handleAdd()" v-hasPermi="['video:push:add']">
          <a-icon type="plus" />根据用户Id发送push
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['video:push:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <table-setting :style="{ float: 'right' }" :table-size.sync="tableSize" v-model="columns" :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList" />
      <create-form-v2 ref="createFormV2" @ok="getList" />
      <!-- 数据展示 -->
      <a-table :loading="loading" :size="tableSize" rowKey="id" :columns="columns" :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :pagination="false"
        :bordered="tableBordered">
        <span slot="sendTime" slot-scope="text, record">
          {{ parseTime(record.sendTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['video:push:edit']" />
          <a @click="handleEdit(record)" v-hasPermi="['video:push:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['video:push:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['video:push:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :current="queryParam.pageNum"
        :total="total" :page-size="queryParam.pageSize" :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange" @change="changeSize" />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pagePush, listPush, delPush } from '@/api/video/push'
import CreateForm from './modules/CreateForm'
import CreateFormV2 from './modules/CreateFormV2'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Push',
  components: {
    CreateForm,
    CreateFormV2
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        content: null,
        contentEn: null,
        toPage: null,
        toUser: null,
        timeType: null,
        sendTime: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
      {
          title: 'id',
          dataIndex: 'id',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '标题',
          dataIndex: 'title',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '英文标题',
          dataIndex: 'titleEn',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '日语标题',
          dataIndex: 'titleJa',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '内容',
          dataIndex: 'content',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '英文内容',
          dataIndex: 'contentEn',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '日语内容',
          dataIndex: 'contentJa',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '跳转页面',
          dataIndex: 'toPage',
          ellipsis: true,
          align: 'center',
          customRender: function (toPage) {
            if (toPage == 1) {
              return '单部剧详情'
            } else if (toPage == 2) {
              return 'rewards页面'
            } else if (toPage == 3) {
              return 'most trending'
            } else if (toPage == 4) {
              return '剧集列表'
            } else if (toPage == 5) {
              return '会员购买页'
            }
          }
        },
        {
          title: '推送用户',
          dataIndex: 'toUser',
          ellipsis: true,
          align: 'center',
          customRender: function (toUser) {
            if (toUser == 1) {
              return '全站'
            } else if (toUser == 2) {
              return '有资格的用户'
            } else if (toUser == 3) {
              return '周/月/年订阅用户'
            } else if (toUser == 4) {
              return '有金币消费历史用户'
            } else if (toUser == 5) {
              return '游客'
            } else if (toUser == 6) {
              return '注册用户'
            } else if (toUser == 9) {
              return '指定用户Id'
            }
          }
        },
        {
          title: '发送时间',
          dataIndex: 'sendTime',
          scopedSlots: { customRender: 'sendTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created() {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    handleEdit(record) {
      if (record.toUser === 9) {
        this.$refs.createFormV2.handleUpdate(record, undefined)
      } else {
        this.$refs.createForm.handleUpdate(record, undefined)
      }
    },
    /** 查询平台推送列表 */
    getList() {
      this.loading = true
      pagePush(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        content: undefined,
        toPage: undefined,
        toUser: undefined,
        timeType: undefined,
        sendTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk() {
          const data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delPush(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel() {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download('video/platform-push/export', {
            ...that.queryParam
          }, `平台推送_${new Date().getTime()}.xlsx`)
        },
        onCancel() { }
      })
    }
  }
}
</script>
